import { ArrowRight } from 'lucide-react';

export default function CTA() {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-section-cta">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl font-bold text-theme-primary mb-4">
          Ready to Secure Your Perfect Domain?
        </h2>
        <p className="text-xl text-theme-secondary mb-8">
          Join thousands of businesses and individuals who trust com0.org for their domain needs.
        </p>

        <a
          href="https://domains0.com"
          target="_blank"
          rel="noopener noreferrer"
          className="glass-button text-white px-8 py-4 rounded-lg font-semibold flex items-center justify-center gap-2 max-w-xl mx-auto"
        >
          Get Started
          <ArrowRight className="h-5 w-5" />
        </a>
      </div>
    </section>
  );
}
